import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  return (
    <footer className="bg-zinc-950 text-white pt-20 pb-10 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] bg-red-600/10 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="col-span-1 md:col-span-4">
            <Link to="/" className="flex items-center gap-2 mb-6 group">
              <SafeIcon icon={FiIcons.FiShield} className="text-4xl text-red-500 group-hover:text-red-400 transition-colors" />
              <span className="font-extrabold text-3xl tracking-tighter">Insurance<span className="text-red-500">Secrets</span></span>
            </Link>
            <p className="text-zinc-400 text-sm leading-relaxed mb-8 pr-4">
              World-class commercial insurance solutions engineered to protect, scale, and secure your business with uncompromising confidence.
            </p>
            <div className="flex space-x-5">
              {['FiLinkedin', 'FiTwitter', 'FiFacebook'].map((icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:bg-red-600 hover:text-white transition-all duration-300">
                  <SafeIcon icon={FiIcons[icon]} className="text-lg" />
                </a>
              ))}
            </div>
          </div>
          <div className="col-span-1 md:col-span-3 md:col-start-6">
            <h4 className="text-lg font-bold mb-6 text-white tracking-wide">Our Expertise</h4>
            <ul className="space-y-3 text-zinc-400 text-sm font-medium">
              <li><Link to="/services/business-commercial" className="hover:text-red-400 transition-colors flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-red-600"/> Business Commercial</Link></li>
              <li><Link to="/services/general-liability" className="hover:text-red-400 transition-colors flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-red-600"/> General Liability</Link></li>
              <li><Link to="/services/workers-compensation" className="hover:text-red-400 transition-colors flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-red-600"/> Workers Comp</Link></li>
              <li><Link to="/services/business-owner-policy" className="hover:text-red-400 transition-colors flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-red-600"/> Business Owner Policy</Link></li>
            </ul>
          </div>
          <div className="col-span-1 md:col-span-3">
            <h4 className="text-lg font-bold mb-6 text-white tracking-wide">Direct Contact</h4>
            <ul className="space-y-5 text-zinc-400 text-sm font-medium">
              <li className="flex items-start gap-4">
                <div className="bg-zinc-900 p-2 rounded-lg text-red-500 mt-0.5"><SafeIcon icon={FiIcons.FiMapPin} /></div>
                <span>5300 West Hillsboro,<br />Ste 105<br />Coconut Creek, FL 33073</span>
              </li>
              <li className="flex items-center gap-4">
                <div className="bg-zinc-900 p-2 rounded-lg text-red-500"><SafeIcon icon={FiIcons.FiPhone} /></div>
                <a href="tel:7192701028" className="text-white font-bold hover:text-red-400 transition-colors">(719) 270-1028</a>
              </li>
              <li className="flex items-center gap-4">
                <div className="bg-zinc-900 p-2 rounded-lg text-red-500"><SafeIcon icon={FiIcons.FiMail} /></div>
                <a href="mailto:support@insurancesecretsonline.com" className="hover:text-red-400 transition-colors cursor-pointer">support@insurancesecretsonline.com</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-zinc-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-medium text-zinc-500">
          <p>&copy; {new Date().getFullYear()} Insurance Secrets. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}